<template>
    <img :src="avatarUrl(user)" />
</template>

<script>
import { useThemeStore } from "@/stores/themeStore";

export default {
    name: "Avatar",
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    methods: {
        avatarUrl(user) {
            const themeStore = useThemeStore();

            const fallbackAvatar = themeStore.isDark
                ? "/default-avatar-dark.svg"
                : "/default-avatar-lite.svg";

            const userpic = user?.userpic;

            if (!userpic?.related) return fallbackAvatar;

            return import.meta.env.VITE_IMG_BASE_URL + userpic.related;
        }
    }
};
</script>


<style></style>
